import useDefinedContext from "hooks/useDefinedContext";
import ParentDimensionsContext from "../contexts/ParentDimensionsContext";

function useParentDimensions() {
  return useDefinedContext(ParentDimensionsContext);
}
export default useParentDimensions;
